import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

import { RequestFinalScreen } from 'components';
import { useCreditRequestForm } from 'context';
import { IRootState } from 'config/redux';
import { AppConstants, ServiceConstants } from '../../../constants';
import { AppUtils } from 'utils';
import { CreditService } from 'services';
import CreditRequestInfoData from '../info';

const { CREDIT_REQUEST_STEP_OVERVIEW } = AppConstants;
const { REQUEST_CREDIT_REQUEST_ID } = ServiceConstants;

const CreditRequestOverviewPage = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const cid = searchParams.get('cid');
  const { setActiveStep, currentCredit, setCurrentCredit, setIsSubmitted, setIsEditable } = useCreditRequestForm();
  const getServiceObject = useSelector((state: IRootState) => state.service.object[REQUEST_CREDIT_REQUEST_ID]);

  useEffect(() => {
    setActiveStep(CREDIT_REQUEST_STEP_OVERVIEW);
    setIsSubmitted(true);
    if (AppUtils.isEmpty(currentCredit) && !AppUtils.isEmpty(cid)) {
      CreditService.getRequest(cid!);
    }
  }, []);

  useEffect(() => {
    AppUtils.resolveServiceObject(
      getServiceObject,
      REQUEST_CREDIT_REQUEST_ID,
      (val) => {
        if (val.requestedAt) {
          setIsEditable(false);
        }
        setCurrentCredit({
          id: val.id,
          creditAmount: val.creditAmount,
          paymentPeriod: val.paymentPeriod,
          monthlyInstallmentTo: val.monthlyInstallmentTo,
          status: val.status,
          requestedAt: val.requestedAt,
          user: val.user,
        });
      }
    );
  }, [getServiceObject]);

  return (
    <>
      <CreditRequestInfoData
        creditAmount={currentCredit.creditAmount}
        paymentPeriod={currentCredit.paymentPeriod}
        monthlyInstallmentTo={currentCredit.monthlyInstallmentTo}
        t={t}
      />
      <RequestFinalScreen
        title={t('credit.overview.title')}
        description={t('credit.overview.description')}
        additionalText={t('credit.overview.notification', { email: currentCredit.user?.email ?? '---' })}
      />
    </>
  )
}

export default CreditRequestOverviewPage;